import angular from 'angular';

import {
  LspGridComponent,
  LspMobileSortComponent,
  LspTableComponent,
} from './lsp-grid-component';

export default angular
  .module('lsp-grid', [])
  .component('lspGrid', new LspGridComponent())
  .component('lspTable', new LspTableComponent())
  .component('lspMobileSort', new LspMobileSortComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-grid/lsp-grid-module.js